import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../assets/styles/Connexion.css';

/**
 * Garde des pages internes : sans compte connecté, on renvoie à la
 * connexion en retenant la page demandée, pour y revenir juste après.
 */
function RequireAuth({ children }) {
  const { utilisateur, chargement } = useAuth();
  const location = useLocation();

  if (chargement) return <div className="connexion-attente">Chargement…</div>;

  if (!utilisateur) {
    return (
      <Navigate
        to="/connexion"
        replace
        state={{ de: `${location.pathname}${location.search}` }}
      />
    );
  }

  return children;
}

export default RequireAuth;
